



























import Candle from "@/models/candle";
import { Component, Prop, Vue } from "vue-property-decorator";

let canvasId = 0;
const fancyFlame = false;

function generateCandleStyle() {
  const rotate = Math.floor(Math.random() * 5 - 2);
  const skew1 = Math.floor(Math.random() * 2 - 1);
  const skew2 = Math.floor(Math.random() * 2 - 1);
  const scale = Math.random() * 0.25 + 0.85;
  return `transform: rotate(${rotate}deg) scaleY(${scale}) skew(${skew1}deg, ${skew2}deg);`;
}

@Component
export default class CandleImage extends Vue {
  private readonly candleCanvasId = "cc" + (canvasId += 1);
  private readonly candleStyle = generateCandleStyle();
  private canvas?: HTMLCanvasElement;

  /**
   * Applies a random delay to the CSS animation.
   */
  private animationDelay = 0;

  @Prop()
  private candle?: Candle;

  @Prop({ default: false })
  private lit?: boolean;

  @Prop({
    default: "normal",
    validator: (x) =>
      ["normal", "small", "big"].findIndex((y) => y === x) !== -1,
  })
  private scale?: string;

  get text() {
    const name = (this.candle || {}).name;
    return name;
  }

  get isLit() {
    return this.lit || Boolean(this.candle);
  }

  get fancyFlame() {
    return fancyFlame;
  }

  // MARK: Lifecycle
  mounted() {
    /*
    if (fancyFlame) {
      const cElement: any = document.getElementById(this.candleCanvasId);
      const ctx = (this.canvas = cElement.getContext("2d"));

      // TODO: Entry point for creating flames on a canvas.
    }
    */

   setTimeout(() => {
      this.animationDelay = Math.ceil(Math.random() * 1000);
   }, 4000);
  }

  // MARK: Handlers
  handleClick() {
    this.$emit("click-candle", this.candle);
  }
}
